import PropTypes from 'prop-types';
import React from 'react';
import bindAll from 'lodash.bindall';
import classNames from 'classnames';
import styles from '../components/menu-bar/comProjectSelection.css';



class ComProjectSelection extends React.Component {
    constructor (props) {
        super(props);
        // bindAll(this, [
        //     'handlePeripheralListUpdate',
        //     'handlePeripheralScanTimeout',
        //     'handleRefresh'
        // ]);
        this.state = {
            isShow: false,
            loading: false,
            data: null,
            pressed: false,
            list_type: "project_list"
        };
    }
    componentDidMount () {
        
        
    }
    componentWillUnmount () {
        if ( this.tm ) {
            clearTimeout( this.tm );
            this.tm = null;
        }
    }
    
    showHide( p_bln, p_list_type ){
        this.setState({ isShow: p_bln, list_type: ( p_list_type || this.state.list_type ) }, () => {
            if ( p_bln ) {
                this.state.data = null;
                this.load_list();
            }
        });
    }

    renderButtons(){
        let obj = [];

        // console.log( "data", this.state.data )

        this.state.data.forEach( ( value, index ) => {
            obj.push( <button key={index}
                className={classNames( styles.button ) }
                onClick={() => { 
                    console.log( value );

                    this.state.pressed = true;
                    if ( this.tm )  {
                        clearTimeout( this.tm );
                        this.tm = null;
                    }
                    
                    this.tm = setTimeout( () =>{ 
                        this.state.pressed = false; 
                    }, 200 );
                    window.location = window.location.href.split( "?" )[ 0 ] + "?" + ( this.state.list_type == "project_list" ? "project" : "tutorial" ) + "=" + value
                }}> 
                {value}.sb3
            </button>);
        })

        return (
            <div className={styles.btn_container}>
                {obj}
            </div>);

    }

    load_list() {
        this.setState( {loading: true}, () => {
            fetch("https://stemacademy.edu.my/tutor/" + this.state.list_type + ".php")
            .then( response => response.json() )
            .then( ( data ) => { 
                // console.log( data ))
                this.setState({ loading: false, data: data });
            })
            .catch(function (err) {
                console.log("Unable to fetch -", err);
            });
        })
    }

    render () {
        if ( this.state.isShow == false ) {
            return null;
        }
        return (
            <div
                className={classNames(
                    styles.container
                )}
                onClick={( e )=>{
                    if ( !this.state.pressed ) {
                        console.log( "e", e );
                        this.showHide( false );
                    }
                }}
            >
                <div className={classNames(
                    styles.holder
                )}>
                    { this.state.loading && 
                        <div className={ classNames( styles.loader ) }></div>
                    } 
                    { this.state.loading == false && this.state.data != null && 
                        this.renderButtons()
                    }
                </div>
            </div>
        );
    }
}

// ComProjectSelection.propTypes = {
//     connectionSmallIconURL: PropTypes.string,
    
// };

export default ComProjectSelection;
